import { render, staticRenderFns } from "./render-name-column-value.vue?vue&type=template&id=fb4ab8de"
import script from "./render-name-column-value.vue?vue&type=script&lang=js"
export * from "./render-name-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb4ab8de')) {
      api.createRecord('fb4ab8de', component.options)
    } else {
      api.reload('fb4ab8de', component.options)
    }
    module.hot.accept("./render-name-column-value.vue?vue&type=template&id=fb4ab8de", function () {
      api.rerender('fb4ab8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-name-column-value.vue"
export default component.exports